import BreakdownCard, {
  BreakdownRow,
} from "@/components/molecules/cards/dashboard/BreakdownCard";
import DashboardDateRangeFilter from "@/components/molecules/cards/dashboard/DashboardDateRangeFilter";
import {
  defaultDashboardEndDate,
  defaultDashboardStartDate,
} from "@/helpers/DashboardDateHelpers";
import { DashboardDossierUserStatBlock } from "@/interfaces/DashboardDossierUserStats";
import { useGetDashboardDossierUserStatsQuery } from "@/services/admin/dashboardDossierUserStats";
import { FC, useState } from "react";
import { Col, Row } from "react-bootstrap";

const PALETTE = [
  "#2c7be5",
  "#27bcfd",
  "#00d27a",
  "#f5803e",
  "#e63757",
  "#9da9bb",
  "#748194",
  "#a16eff",
  "#fac620",
  "#3874ff",
];

const userRows = (block?: DashboardDossierUserStatBlock): BreakdownRow[] =>
  (block?.rows ?? []).map((row, index) => ({
    key: row.userId,
    label: `${row.userLabel} (${row.roles.join(", ")})`,
    color: PALETTE[index % PALETTE.length],
    amount: row.total,
    count: row.count,
  }));

const PerformanceStatsSection: FC = () => {
  const [startDate, setStartDate] = useState<string>(defaultDashboardStartDate);
  const [endDate, setEndDate] = useState<string>(defaultDashboardEndDate);

  const { data, isFetching } = useGetDashboardDossierUserStatsQuery({
    startDate: startDate || undefined,
    endDate: endDate || undefined,
  });

  return (
    <>
      <DashboardDateRangeFilter
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
      />
      <Row className="g-3">
        <Col md={4}>
          <BreakdownCard
            title="Montant demandé par utilisateur"
            description="CSM, AE, SDR — un dossier crédite chacun de ses rôles assignés"
            metric="amount"
            rows={userRows(data?.askingPrice)}
            grandAmount={data?.askingPrice.grandTotal}
            grandCount={data?.askingPrice.grandCount ?? 0}
            isLoading={isFetching}
          />
        </Col>
        <Col md={4}>
          <BreakdownCard
            title="Montant accordé par utilisateur"
            metric="amount"
            rows={userRows(data?.agreementAmount)}
            grandAmount={data?.agreementAmount.grandTotal}
            grandCount={data?.agreementAmount.grandCount ?? 0}
            isLoading={isFetching}
          />
        </Col>
        <Col md={4}>
          <BreakdownCard
            title="Montant facturé par utilisateur"
            metric="amount"
            rows={userRows(data?.invoiceAmount)}
            grandAmount={data?.invoiceAmount.grandTotal}
            grandCount={data?.invoiceAmount.grandCount ?? 0}
            isLoading={isFetching}
          />
        </Col>
      </Row>
    </>
  );
};

export default PerformanceStatsSection;
